import { createContext, useCallback, useState } from 'react';

/**
 *
 * 다수 메뉴의 드랍다운을 핸들링하기 위한 context
 */

const MenuContext = createContext({
  visible: null,
  toggle: () => {},
  close: () => {},
});

export const MenuProvider = ({ children }) => {
  const [visible, setVisible] = useState(null);

  const toggle = useCallback((id) => {
    // 동일한 id 클릭시 -> 클로징
    // 다른 id 클릭시 -> 오픈
    setVisible((prev) => (!prev || prev !== id ? id : null));
  }, []);

  const close = useCallback(() => {
    setVisible(null);
  }, []);

  return (
    <MenuContext.Provider value={{ visible, toggle, close }}>
      {children}
    </MenuContext.Provider>
  );
};

export default MenuContext;
